import React from 'react';
import { Circle } from './Variants/Circle/Circle';
import { SmallCircle } from './Variants/SmallCircle/SmallCircle';

export const SpinnerVariants = {
  CIRCLE: 'Circle',
  SMALL_CIRCLE: 'SmallCircle',
} as const;

type SpinnerProps =
  | { variant: typeof SpinnerVariants.CIRCLE }
  | { variant: typeof SpinnerVariants.SMALL_CIRCLE };

export const Spinner: React.FC<SpinnerProps> = React.memo((props) => {
  switch (props.variant) {
    case SpinnerVariants.CIRCLE:
      return <Circle />;
    case SpinnerVariants.SMALL_CIRCLE:
      return <SmallCircle />;
  }
});

Spinner.displayName = 'Spinner';
